import React, { FC, useCallback, useMemo } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { CustomTable } from '../../../../../components';
import { DetailsModel } from '../../MasteIBCommissionModel';
import { useCommonStyles } from '../../../../../styles';

interface Props {
  rows: DetailsModel[];
  reportColumns: string[];
  translation: any;
}

export const DetailedTable: FC<Props> = ({ rows, reportColumns, translation }) => {
  const commonClasses = useCommonStyles();

  const renderHeader = useMemo((): any[] => {
    const result: any[] = [];
    reportColumns.forEach((columnName) => {
      result.push(
        <TableCell key={columnName} align="left">
          {columnName}
        </TableCell>,
      );
    });
    return result;
  }, [reportColumns]);

  const renderRows = useCallback((): any[] => {
    const result: any[] = [];
    rows.forEach((row: any) => {
      result.push(
        <TableRow key={uuid()} className={commonClasses.tableRow}>
          <TableCell align="left">{row.subPartnershipCode ? row.subPartnershipCode : '-'}</TableCell>
          <TableCell align="left">{row.depositUSD || row.depositUSD === 0 ? `$${row.depositUSD.toFixed(2)}` : '-'}</TableCell>
          <TableCell align="left">{row.withdrawalUSD || row.withdrawalUSD === 0 ? `$${Math.abs(row.withdrawalUSD).toFixed(2)}` : '-'}</TableCell>
          <TableCell align="left">{row.lastBalanceUSD || row.lastBalanceUSD === 0 ? `$${row.lastBalanceUSD.toFixed(2)}` : '-'}</TableCell>
        </TableRow>,
      );
    });

    return result;
  }, [rows, commonClasses]);

  return <CustomTable headerCells={renderHeader} rows={renderRows()} columnsNumber={reportColumns.length} emptyDataMessage={translation.text_833} />;
};
